// Theme: matrix-chrome
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'matrix-chrome',
  name: 'MATRIX CHROME',
  tagline: 'MATRIX CHROME',
  description: 'Variante cromada de Matrix com ciano metalico e chuva de codigo.',
  category: 'neon-cyber',
  tier: 'epic',
  basePrice: 3675,
  swatches: ['#0E1718', '#1A2A2A', '#75C8C9', '#D4F4F4'],
  familyId: 'matrix',
  variantName: 'CHROME',
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '12px',
      '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.24)',
      '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)'
    },
    shellClasses: 'font-mono theme-matrix-chrome'
  },
  colorVars: {
    '--accent': '#75C8C9',
    '--accent-foreground': '#0E1718',
    '--background': '#0E1718',
    '--border': '#3A7A7A',
    '--card': '#1A2A2A',
    '--card-border-active': 'rgba(117, 200, 201, 0.55)',
    '--card-completed': '#152222',
    '--card-foreground': '#D4F4F4',
    '--card-glow': 'rgba(117, 200, 201, 0.10)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0a0a0a',
    '--foreground': '#D4F4F4',
    '--hold-fill': '#75C8C9',
    '--input': '#3A7A7A',
    '--modal-bg': '#0E1718',
    '--modal-border': '#3A7A7A',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.24)',
    '--muted': '#3A7A7A',
    '--muted-foreground': '#D4F4F4',
    '--nav-active': '#75C8C9',
    '--nav-bg': '#1A2A2A',
    '--popover': '#1A2A2A',
    '--popover-foreground': '#D4F4F4',
    '--primary': '#75C8C9',
    '--primary-foreground': '#0E1718',
    '--ring': '#75C8C9',
    '--secondary': '#3A7A7A',
    '--secondary-foreground': '#D4F4F4',
    '--streak': '#75C8C9',
    '--success': '#22c55e',
    '--success-foreground': '#0E1718',
    '--xp': '#75C8C9',
    '--xp-bg': '#1A2A2A'
  },
  resolvedVars: {
    '--accent': '#75C8C9',
    '--accent-foreground': '#0E1718',
    '--accent-foreground-hsl': '186 26% 7%',
    '--accent-foreground-oklch': 'from #0E1718 l c h',
    '--accent-hsl': '181 44% 62%',
    '--accent-oklch': 'from #75C8C9 l c h',
    '--background': '#0E1718',
    '--background-hsl': '186 26% 7%',
    '--background-oklch': 'from #0E1718 l c h',
    '--border': '#3A7A7A',
    '--border-hsl': '180 36% 35%',
    '--border-oklch': 'from #3A7A7A l c h',
    '--border-w': '1px',
    '--card': '#1A2A2A',
    '--card-border-active': 'rgba(117, 200, 201, 0.55)',
    '--card-completed': '#152222',
    '--card-completed-hsl': '180 24% 11%',
    '--card-completed-oklch': 'from #152222 l c h',
    '--card-foreground': '#D4F4F4',
    '--card-foreground-hsl': '180 59% 89%',
    '--card-foreground-oklch': 'from #D4F4F4 l c h',
    '--card-glow': 'rgba(117, 200, 201, 0.10)',
    '--card-hsl': '180 24% 13%',
    '--card-oklch': 'from #1A2A2A l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0a0a0a',
    '--destructive-foreground-hsl': '0 0% 4%',
    '--destructive-foreground-oklch': 'from #0a0a0a l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#D4F4F4',
    '--foreground-hsl': '180 59% 89%',
    '--foreground-oklch': 'from #D4F4F4 l c h',
    '--hold-fill': '#75C8C9',
    '--hold-fill-hsl': '181 44% 62%',
    '--hold-fill-oklch': 'from #75C8C9 l c h',
    '--input': '#3A7A7A',
    '--input-hsl': '180 36% 35%',
    '--input-oklch': 'from #3A7A7A l c h',
    '--modal-bg': '#0E1718',
    '--modal-bg-hsl': '186 26% 7%',
    '--modal-bg-oklch': 'from #0E1718 l c h',
    '--modal-border': '#3A7A7A',
    '--modal-border-hsl': '180 36% 35%',
    '--modal-border-oklch': 'from #3A7A7A l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.24)',
    '--muted': '#3A7A7A',
    '--muted-foreground': '#D4F4F4',
    '--muted-foreground-hsl': '180 59% 89%',
    '--muted-foreground-oklch': 'from #D4F4F4 l c h',
    '--muted-hsl': '180 36% 35%',
    '--muted-oklch': 'from #3A7A7A l c h',
    '--nav-active': '#75C8C9',
    '--nav-active-hsl': '181 44% 62%',
    '--nav-active-oklch': 'from #75C8C9 l c h',
    '--nav-bg': '#1A2A2A',
    '--nav-bg-hsl': '180 24% 13%',
    '--nav-bg-oklch': 'from #1A2A2A l c h',
    '--popover': '#1A2A2A',
    '--popover-foreground': '#D4F4F4',
    '--popover-foreground-hsl': '180 59% 89%',
    '--popover-foreground-oklch': 'from #D4F4F4 l c h',
    '--popover-hsl': '180 24% 13%',
    '--popover-oklch': 'from #1A2A2A l c h',
    '--primary': '#75C8C9',
    '--primary-foreground': '#0E1718',
    '--primary-foreground-hsl': '186 26% 7%',
    '--primary-foreground-oklch': 'from #0E1718 l c h',
    '--primary-hsl': '181 44% 62%',
    '--primary-oklch': 'from #75C8C9 l c h',
    '--radius': '12px',
    '--ring': '#75C8C9',
    '--ring-hsl': '181 44% 62%',
    '--ring-oklch': 'from #75C8C9 l c h',
    '--secondary': '#3A7A7A',
    '--secondary-foreground': '#D4F4F4',
    '--secondary-foreground-hsl': '180 59% 89%',
    '--secondary-foreground-oklch': 'from #D4F4F4 l c h',
    '--secondary-hsl': '180 36% 35%',
    '--secondary-oklch': 'from #3A7A7A l c h',
    '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.24)',
    '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)',
    '--streak': '#75C8C9',
    '--streak-hsl': '181 44% 62%',
    '--streak-oklch': 'from #75C8C9 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#0E1718',
    '--success-foreground-hsl': '186 26% 7%',
    '--success-foreground-oklch': 'from #0E1718 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(181 44% 62% / 0.15)',
    '--xp': '#75C8C9',
    '--xp-bg': '#1A2A2A',
    '--xp-bg-hsl': '180 24% 13%',
    '--xp-bg-oklch': 'from #1A2A2A l c h',
    '--xp-hsl': '181 44% 62%',
    '--xp-oklch': 'from #75C8C9 l c h'
  }
}
